// import React, { useState } from "react";
// import API from "./axiosInstance";

// function AddReview({ productId }) {
//   const [rating, setRating] = useState(5);
//   const [comment, setComment] = useState("");

//   const submitReview = async (e) => {
//     e.preventDefault();

//     try {
//       await API.post(
//         "/reviews/add",
//         { productId, rating, comment },
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       alert("Review submitted!");
//       setComment("");
//     } catch (err) {
//       alert("You must be logged in to review");
//     }
//   };

//   return (
//     <form onSubmit={submitReview} style={{ marginTop: 20 }}>
//       <h4>Write a Review</h4>

//       <select value={rating} onChange={(e) => setRating(e.target.value)}>
//         <option value="5">⭐ 5</option>
//         <option value="4">⭐ 4</option>
//         <option value="3">⭐ 3</option>
//         <option value="2">⭐ 2</option>
//         <option value="1">⭐ 1</option>
//       </select>

//       <textarea
//         placeholder="Write your review..."
//         value={comment}
//         onChange={(e) => setComment(e.target.value)}
//         required
//         style={{ width: "100%", marginTop: 10 }}
//       />

//       <button type="submit" style={{ marginTop: 10 }}>
//         Submit Review
//       </button>
//     </form>
//   );
// }

// export default AddReview;
import React, { useState } from "react";
import API from "./axiosInstance";

function AddReview({ productId, onReviewAdded }) {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");

  const token = localStorage.getItem("token");

  const handleSubmit = async () => {
    await API.post(
      "/reviews",
      { productId, rating, comment },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setRating(0);
    setComment("");

    onReviewAdded(); // ⭐ parent ko refresh signal
  };

  return (
    <div>
      <h3>Add Review</h3>

      <input
        type="number"
        min="1"
        max="5"
        value={rating}
        onChange={(e) => setRating(e.target.value)}
        placeholder="Rating 1-5"
      />
      <br />

      <textarea
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        placeholder="Write your review"
      />

      <br />

      <button onClick={handleSubmit}>Submit Review</button>
    </div>
  );
}

export default AddReview;
